export const TEST_ID = 'serviceIntervalConfigPanel';

export const HELPER_TEXT_TEST_ID = 'serviceIntervalConfigHelperText';

export const FOOTER_TEST_ID = 'intervalConfigFooter';

export const FOOTER_CANCEL_BUTTON_TEST_ID = 'intervalConfigFooterCancelButton';

export const FOOTER_SAVE_BUTTON_TEST_ID = 'intervalConfigFooterSaveButton';
